// extracted by mini-css-extract-plugin
module.exports = {"full-width":"style-module_full-width__Kx2G4pBdUFdx721W5jqi","fullWidth":"style-module_full-width__Kx2G4pBdUFdx721W5jqi","container":"style-module_container__FyN67DOfYzce7WX3Z7zt"};